import React from "react";
import Seo from "@/components/Seo";

const Box = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="font-heading font-bold text-xl sm:text-2xl text-slate-900 mb-3">{title}</h2>
    <div className="text-slate-700 leading-relaxed space-y-3">{children}</div>
  </section>
);

const LegalNoticePage = () => (
  <>
    <Seo titleKey="seo.legal_title" descKey="seo.legal_desc" path="/mentions-legales" />
    <section className="container-x max-w-3xl pt-12 pb-20">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue">Légal</p>
      <h1 className="mt-2 font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl text-slate-900">
        Mentions légales
      </h1>
      <p className="mt-3 text-sm text-slate-500">
        Conformément aux articles 6-III et 19 de la loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'Économie Numérique (LCEN).
      </p>

      <div className="mt-10">

        <Box title="1. Éditeur du site">
          <p>
            <strong>BIONET SOLUTIONS</strong><br />
            Forme juridique : SAS, société par actions simplifiée<br />
            Capital social : 1 000,00 €<br />
            Siège social : 64 chemin de Sermenaz, 01700 Neyron, France<br />
            SIRET : 944 251 479 00019<br />
            RCS : 944 251 479 R.C.S. Bourg-en-Bresse<br />
            Code APE : 8121Z (Nettoyage courant des bâtiments)<br />
            N° TVA intracommunautaire : FR11944251479<br />
            Téléphone : 06 49 50 28 01<br />
            Email :{" "}
            <a href="mailto:contact@bionet-solutions.com" className="text-brand-blue hover:underline">
              contact@bionet-solutions.com
            </a>
          </p>
        </Box>

        <Box title="2. Directeur de la publication">
          <p>
            Yanis Benlama, Président<br />
            Joignable à :{" "}
            <a href="mailto:contact@bionet-solutions.com" className="text-brand-blue hover:underline">
              contact@bionet-solutions.com
            </a>
          </p>
        </Box>

        <Box title="3. Hébergeur">
          <p>
            <strong>Hetzner Online GmbH</strong><br />
            Industriestr. 25<br />
            91710 Gunzenhausen, Allemagne<br />
            Site web :{" "}
            <a href="https://www.hetzner.com" target="_blank" rel="noopener noreferrer" className="text-brand-blue hover:underline">
              www.hetzner.com
            </a>
          </p>
        </Box>

        <Box title="4. Propriété intellectuelle">
          <p>
            L'ensemble des éléments constituant le site <strong>bionet-solutions.com</strong> (textes, graphismes, logiciels, photographies, images, sons, plans, noms, logos, marques, créations et œuvres protégeables diverses) est la propriété exclusive de BIONET SOLUTIONS ou fait l'objet d'une autorisation d'utilisation. Ces éléments sont protégés par les lois françaises et internationales relatives à la propriété intellectuelle.
          </p>
          <p>
            Toute reproduction, représentation, modification, publication, transmission ou dénaturation, totale ou partielle, du site ou de son contenu, par quelque procédé que ce soit, et sur quelque support que ce soit, est interdite sans l'autorisation écrite préalable de BIONET SOLUTIONS.
          </p>
        </Box>

        <Box title="5. Limitation de responsabilité">
          <p>
            Les informations diffusées sur ce site sont présentées à titre indicatif et ne sauraient constituer des engagements contractuels. BIONET SOLUTIONS s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées, mais ne peut en garantir l'exhaustivité ni l'absence d'erreur.
          </p>
          <p>
            BIONET SOLUTIONS ne saurait être tenu responsable des dommages directs ou indirects résultant de l'accès ou de l'utilisation du site, ni des liens hypertextes renvoyant vers des sites tiers dont le contenu échappe à son contrôle.
          </p>
        </Box>

        <Box title="6. Données personnelles et RGPD">
          <p>
            BIONET SOLUTIONS collecte des données personnelles (nom, email, téléphone) uniquement dans le cadre de demandes de devis et de messages de contact, sur la base de votre consentement explicite (case RGPD cochée).
          </p>
          <p>
            Conformément au Règlement (UE) 2016/679 (RGPD) et à la loi n° 78-17 du 6 janvier 1978 modifiée, vous disposez des droits suivants sur vos données :
          </p>
          <ul className="list-disc list-inside space-y-1 text-slate-600">
            <li>Droit d'accès et de rectification</li>
            <li>Droit à l'effacement (« droit à l'oubli »)</li>
            <li>Droit d'opposition et de limitation du traitement</li>
            <li>Droit à la portabilité des données</li>
          </ul>
          <p>
            Pour exercer ces droits ou pour toute question relative à la protection de vos données, contactez-nous à :{" "}
            <a href="mailto:contact@bionet-solutions.com" className="text-brand-blue hover:underline">
              contact@bionet-solutions.com
            </a>.<br />
            Vous pouvez également adresser une réclamation à la{" "}
            <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-brand-blue hover:underline">
              CNIL
            </a>{" "}
            (Commission Nationale de l'Informatique et des Libertés).
          </p>
          <p>
            <strong>Durées de conservation :</strong>
          </p>
          <ul className="list-disc list-inside space-y-1 text-slate-600">
            <li><strong>Prospect (contact ou devis sans suite) :</strong> 3 ans à compter du dernier contact, conformément aux recommandations de la CNIL.</li>
            <li><strong>Client (devis suivi d'une prestation) :</strong> durée de la relation commerciale, puis 5 ans en archivage intermédiaire au titre de la prescription commerciale (art. L. 110-4 du Code de commerce).</li>
            <li><strong>Pièces comptables liées à une facturation :</strong> 10 ans à compter de la clôture de l'exercice (art. L. 123-22 du Code de commerce).</li>
            <li><strong>Données de conversation (chatbot) :</strong> 1 an à compter de la dernière interaction.</li>
          </ul>
        </Box>

        <Box title="7. Cookies">
          <p>
            Ce site utilise uniquement des cookies strictement nécessaires à son fonctionnement (mémorisation du choix de langue, consentement cookies). Aucun cookie publicitaire ou de pistage tiers n'est déposé sans votre consentement préalable.
          </p>
          <p>
            Vous pouvez à tout moment retirer votre consentement via le bandeau cookies présent sur le site.
          </p>
        </Box>

        <Box title="8. Droit applicable et juridiction compétente">
          <p>
            Les présentes mentions légales sont soumises au droit français. En cas de litige relatif à l'interprétation ou à l'exécution des présentes, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.
          </p>
        </Box>

        <Box title="9. Crédits">
          <p>
            Conception et développement : DAWOOD Mohamad.<br />
            Client : BIONET SOLUTIONS.
          </p>
        </Box>

      </div>

      <p className="mt-10 text-xs text-slate-400 border-t border-slate-200 pt-6">
        Dernière mise à jour : 02 mai 2026
      </p>
    </section>
  </>
);

export default LegalNoticePage;
